import VitaView from './VitaView';

export default VitaView;
